const ELTV_CONFIG: Record<string, number> = {
  everydoggy_2WEEK_29_99_USD_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY: 49.6,
  everydoggy_2WEEK_29_99_USD_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY: 78.42,
  everydoggy_1MONTH_49_99_USD_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY: 105.26,
  everydoggy_2WEEK_29_99_USD_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY: 16.11,
  everydoggy_2WEEK_29_99_USD_INTRO_30days_3_99_EVERYDOGGY_EVERYDOGGY: 44.37,
  everydoggy_1MONTH_49_99_USD_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY: 63.76,

  everydoggy_2WEEK_29_99_USD_INTRO_7days_1_99_VET_CARE_EVERYDOGGY_EVERYDOGGY: 46.51,
  everydoggy_2WEEK_29_99_USD_INTRO_30days_6_99_VET_CARE_EVERYDOGGY_EVERYDOGGY: 75.60,
  everydoggy_1MONTH_49_99_USD_INTRO_90days_14_99_VET_CARE_EVERYDOGGY_EVERYDOGGY: 96.99,

  everydoggy_2WEEK_29_99_GBP_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY: 55.36,
  everydoggy_2WEEK_29_99_GBP_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY: 81.84,
  everydoggy_1MONTH_49_99_GBP_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY: 108.71,
  everydoggy_2WEEK_29_99_GBP_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY: 23.68,
  everydoggy_2WEEK_29_99_GBP_INTRO_30days_3_99_EVERYDOGGY_EVERYDOGGY: 57.5,
  everydoggy_1MONTH_49_99_GBP_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY: 53.47,

  everydoggy_2WEEK_29_99_GBP_INTRO_7days_1_99_VET_CARE_EVERYDOGGY_EVERYDOGGY: 62.78,
  everydoggy_2WEEK_29_99_GBP_INTRO_30days_6_99_VET_CARE_EVERYDOGGY_EVERYDOGGY: 89.33,
  everydoggy_1MONTH_49_99_GBP_INTRO_90days_14_99_VET_CARE_EVERYDOGGY_EVERYDOGGY: 113.95,

  everydoggy_2WEEK_29_99_EUR_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY: 63.17,
  everydoggy_2WEEK_29_99_EUR_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY: 101.85,
  everydoggy_1MONTH_49_99_EUR_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY: 120.86,
  everydoggy_2WEEK_29_99_EUR_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY: 23.92,
  everydoggy_2WEEK_29_99_EUR_INTRO_30days_3_99_EVERYDOGGY_EVERYDOGGY: 48.38,
  everydoggy_1MONTH_49_99_EUR_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY: 65.37,

  everydoggy_2WEEK_29_99_EUR_INTRO_7days_1_99_VET_CARE_EVERYDOGGY_EVERYDOGGY: 58.02,
  everydoggy_2WEEK_29_99_EUR_INTRO_30days_6_99_VET_CARE_EVERYDOGGY_EVERYDOGGY: 82.59,
  everydoggy_1MONTH_49_99_EUR_INTRO_90days_14_99_VET_CARE_EVERYDOGGY_EVERYDOGGY: 116.58,

  everydoggy_1MONTH_39_99_USD_INTRO_7days_6_99_EVERYDOGGY: 72.51,
  everydoggy_1MONTH_39_99_USD_INTRO_30days_14_99_EVERYDOGGY: 80.04,
  everydoggy_3MONTH_59_99_USD_INTRO_90days_29_99_EVERYDOGGY: 65.85,
  everydoggy_1MONTH_39_99_USD_INTRO_7days_4_99_EVERYDOGGY: 49.71,
  everydoggy_1MONTH_39_99_USD_INTRO_30days_11_99_EVERYDOGGY: 63.24,
  everydoggy_3MONTH_59_99_USD_INTRO_90days_19_99_EVERYDOGGY: 51.71,

  everydoggy_1MONTH_49_99_USD_INTRO_7days_4_99_EVERYDOGGY: 76.9,
  everydoggy_1MONTH_49_99_USD_INTRO_30days_11_99_EVERYDOGGY: 95.75,
  everydoggy_3MONTH_79_99_USD_INTRO_90days_25_99_EVERYDOGGY: 71.67,
  everydoggy_1MONTH_49_99_USD_INTRO_7days_3_99_EVERYDOGGY: 35.2,
  everydoggy_1MONTH_49_99_USD_INTRO_30days_8_99_EVERYDOGGY: 48.41,
  everydoggy_3MONTH_79_99_USD_INTRO_90days_19_99_EVERYDOGGY: 75.78,

  everydoggy_1MONTH_49_99_GBP_INTRO_7days_4_99_EVERYDOGGY_EVERYDOGGY: 79.88,
  everydoggy_1MONTH_49_99_GBP_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY: 99.68,
  everydoggy_3MONTH_79_99_GBP_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY: 77.87,
  everydoggy_1MONTH_49_99_GBP_INTRO_7days_3_99_EVERYDOGGY_EVERYDOGGY: 40.25,
  everydoggy_1MONTH_49_99_GBP_INTRO_30days_8_99_EVERYDOGGY_EVERYDOGGY: 56.02,
  everydoggy_3MONTH_79_99_GBP_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY: 88.82,

  everydoggy_1MONTH_49_99_USD_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY: 54.04,
  everydoggy_1MONTH_49_99_USD_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY: 102.58,
  everydoggy_3MONTH_79_99_USD_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY: 64.15,
  everydoggy_1MONTH_49_99_USD_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY: 13.91,
  everydoggy_1MONTH_49_99_USD_INTRO_30days_3_99_NONE_NONE: 32.5,
  everydoggy_3MONTH_79_99_USD_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY: 45.7,

  everydoggy_3MONTH_59_99_USD_INTRO_90days_39_99_EVERYDOGGY_EVERYDOGGY: 91.73,
  everydoggy_1MONTH_39_99_USD_EVERYDOGGY_EVERYDOGGY: 88.3,

  everydoggy_2WEEK_29_99_USD_INTRO_30days_9_99_TRAINER_CHAT_EVERYDOGGY_EVERYDOGGY: 67.89,
  everydoggy_2WEEK_29_99_GBP_INTRO_30days_9_99_TRAINER_CHAT_EVERYDOGGY_EVERYDOGGY: 72.56,
  everydoggy_2WEEK_29_99_EUR_INTRO_30days_9_99_TRAINER_CHAT_EVERYDOGGY_EVERYDOGGY: 74.16,

  everydoggy_1MONTH_39_99_GBP_EVERYDOGGY_EVERYDOGGY: 94.83,
  everydoggy_1MONTH_39_99_GBP_INTRO_30days_14_99_EVERYDOGGY_EVERYDOGGY: 79.16,
  everydoggy_3MONTH_59_99_GBP_INTRO_90days_39_99_EVERYDOGGY_EVERYDOGGY: 100.07,
  everydoggy_1MONTH_39_99_GBP_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY: 63.2,
  everydoggy_3MONTH_59_99_GBP_INTRO_90days_29_99_EVERYDOGGY_EVERYDOGGY: 72.41,

  everydoggy_1MONTH_39_99_EUR_EVERYDOGGY_EVERYDOGGY: 98.98,
  everydoggy_1MONTH_39_99_EUR_INTRO_30days_14_99_EVERYDOGGY_EVERYDOGGY: 86.84,
  everydoggy_3MONTH_59_99_EUR_INTRO_90days_39_99_EVERYDOGGY_EVERYDOGGY: 102.43,
  everydoggy_1MONTH_39_99_EUR_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY: 69.57,
  everydoggy_3MONTH_59_99_EUR_INTRO_90days_29_99_EVERYDOGGY_EVERYDOGGY: 72.55,

  //
  everydoggy_3MONTH_64_99_USD_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY: 83.47,
  everydoggy_6MONTH_94_99_USD_INTRO_180days_37_99_EVERYDOGGY_EVERYDOGGY: 81.38,
  everydoggy_3MONTH_64_99_USD_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY: 80.68,
  everydoggy_6MONTH_94_99_USD_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY: 77.63,
  everydoggy_3MONTH_64_99_USD_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY: 54.98,
  everydoggy_6MONTH_94_99_USD_INTRO_180days_29_99_EVERYDOGGY_EVERYDOGGY: 63.08,

  everydoggy_3MONTH_64_99_GBP_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY: 89.36,
  everydoggy_6MONTH_94_99_GBP_INTRO_180days_37_99_EVERYDOGGY_EVERYDOGGY: 91.59,
  everydoggy_3MONTH_64_99_GBP_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY: 89.98,
  everydoggy_6MONTH_94_99_GBP_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY: 87.17,
  everydoggy_3MONTH_64_99_GBP_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY: 59.99,
  everydoggy_6MONTH_94_99_GBP_INTRO_180days_29_99_EVERYDOGGY_EVERYDOGGY: 71.09,

  everydoggy_3MONTH_64_99_EUR_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY: 95.04,
  everydoggy_6MONTH_94_99_EUR_INTRO_180days_37_99_EVERYDOGGY_EVERYDOGGY: 93.38,
  everydoggy_3MONTH_64_99_EUR_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY: 83.85,
  everydoggy_6MONTH_94_99_EUR_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY: 84.90,
  everydoggy_3MONTH_64_99_EUR_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY: 62.76,
  everydoggy_6MONTH_94_99_EUR_INTRO_180days_29_99_EVERYDOGGY_EVERYDOGGY: 72.41,

  everydoggy_2WEEK_39_99_USD_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY: 77.98,
  everydoggy_1MONTH_49_99_USD_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY: 90.02,
  everydoggy_1MONTH_49_99_USD_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY: 81.39,

  everydoggy_2WEEK_39_99_GBP_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY: 81.08,
  everydoggy_1MONTH_49_99_GBP_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY: 95.89,
  everydoggy_1MONTH_49_99_GBP_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY: 92.34,

  everydoggy_2WEEK_39_99_EUR_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY: 84.17,
  everydoggy_1MONTH_49_99_EUR_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY: 98.09,
  everydoggy_1MONTH_49_99_EUR_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY: 90.17,
};

const ELTV_LOCAL_CONFIG: Record<string, number> = {
  // 29.99 GBP
  everydoggy_2WEEK_29_99_GBP_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY: 41.05,
  everydoggy_2WEEK_29_99_GBP_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY: 60.67,
  everydoggy_1MONTH_49_99_GBP_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY: 80.61,
  everydoggy_2WEEK_29_99_GBP_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY: 17.56,
  everydoggy_2WEEK_29_99_GBP_INTRO_30days_3_99_EVERYDOGGY_EVERYDOGGY: 42.64,
  everydoggy_1MONTH_49_99_GBP_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY: 39.65,

  everydoggy_2WEEK_29_99_GBP_INTRO_7days_1_99_VET_CARE_EVERYDOGGY_EVERYDOGGY: 46.30,
  everydoggy_2WEEK_29_99_GBP_INTRO_30days_6_99_VET_CARE_EVERYDOGGY_EVERYDOGGY: 65.87,
  everydoggy_1MONTH_49_99_GBP_INTRO_90days_14_99_VET_CARE_EVERYDOGGY_EVERYDOGGY: 84.04,

  // 29.99 EUR
  everydoggy_2WEEK_29_99_EUR_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY: 53.71,
  everydoggy_2WEEK_29_99_EUR_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY: 86.6,
  everydoggy_1MONTH_49_99_EUR_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY: 102.76,
  everydoggy_2WEEK_29_99_EUR_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY: 20.34,
  everydoggy_2WEEK_29_99_EUR_INTRO_30days_3_99_EVERYDOGGY_EVERYDOGGY: 41.13,
  everydoggy_1MONTH_49_99_EUR_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY: 55.58,

  everydoggy_2WEEK_29_99_EUR_INTRO_7days_1_99_VET_CARE_EVERYDOGGY_EVERYDOGGY: 49.22,
  everydoggy_2WEEK_29_99_EUR_INTRO_30days_6_99_VET_CARE_EVERYDOGGY_EVERYDOGGY: 70.06,
  everydoggy_1MONTH_49_99_EUR_INTRO_90days_14_99_VET_CARE_EVERYDOGGY_EVERYDOGGY: 98.89,

  // 49.99 GBP
  everydoggy_1MONTH_49_99_GBP_INTRO_7days_4_99_EVERYDOGGY_EVERYDOGGY: 59.27,
  everydoggy_1MONTH_49_99_GBP_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY: 73.96,
  everydoggy_3MONTH_79_99_GBP_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY: 57.78,
  everydoggy_1MONTH_49_99_GBP_INTRO_7days_3_99_EVERYDOGGY_EVERYDOGGY: 29.86,
  everydoggy_1MONTH_49_99_GBP_INTRO_30days_8_99_EVERYDOGGY_EVERYDOGGY: 41.57,
  everydoggy_3MONTH_79_99_GBP_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY: 65.91,

  // TRAINER_CHAT (GBP/EUR) — column F
  everydoggy_2WEEK_29_99_GBP_INTRO_30days_9_99_TRAINER_CHAT_EVERYDOGGY_EVERYDOGGY: 53.84,
  everydoggy_2WEEK_29_99_EUR_INTRO_30days_9_99_TRAINER_CHAT_EVERYDOGGY_EVERYDOGGY: 63.05,

  // no trial / 39.99 GBP
  everydoggy_1MONTH_39_99_GBP_EVERYDOGGY_EVERYDOGGY: 70.36,
  everydoggy_1MONTH_39_99_GBP_INTRO_30days_14_99_EVERYDOGGY_EVERYDOGGY: 58.74,
  everydoggy_3MONTH_59_99_GBP_INTRO_90days_39_99_EVERYDOGGY_EVERYDOGGY: 74.25,
  everydoggy_1MONTH_39_99_GBP_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY: 46.9,
  everydoggy_3MONTH_59_99_GBP_INTRO_90days_29_99_EVERYDOGGY_EVERYDOGGY: 53.73,

  // no trial / 39.99 EUR
  everydoggy_1MONTH_39_99_EUR_EVERYDOGGY_EVERYDOGGY: 84.16,
  everydoggy_1MONTH_39_99_EUR_INTRO_30days_14_99_EVERYDOGGY_EVERYDOGGY: 73.83,
  everydoggy_3MONTH_59_99_EUR_INTRO_90days_39_99_EVERYDOGGY_EVERYDOGGY: 87.09,
  everydoggy_1MONTH_39_99_EUR_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY: 59.15,
  everydoggy_3MONTH_59_99_EUR_INTRO_90days_29_99_EVERYDOGGY_EVERYDOGGY: 61.69,

  //
  everydoggy_3MONTH_64_99_USD_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY: 83.47,
  everydoggy_6MONTH_94_99_USD_INTRO_180days_37_99_EVERYDOGGY_EVERYDOGGY: 81.38,
  everydoggy_3MONTH_64_99_USD_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY: 80.68,
  everydoggy_6MONTH_94_99_USD_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY: 77.63,
  everydoggy_3MONTH_64_99_USD_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY: 54.98,
  everydoggy_6MONTH_94_99_USD_INTRO_180days_29_99_EVERYDOGGY_EVERYDOGGY: 63.08,

  everydoggy_3MONTH_64_99_GBP_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY: 66.69,
  everydoggy_6MONTH_94_99_GBP_INTRO_180days_37_99_EVERYDOGGY_EVERYDOGGY: 68.36,
  everydoggy_3MONTH_64_99_GBP_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY: 67.54,
  everydoggy_6MONTH_94_99_GBP_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY: 65.43,
  everydoggy_3MONTH_64_99_GBP_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY: 44.77,
  everydoggy_6MONTH_94_99_GBP_INTRO_180days_29_99_EVERYDOGGY_EVERYDOGGY: 53.06,

  everydoggy_3MONTH_64_99_EUR_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY: 81.20,
  everydoggy_6MONTH_94_99_EUR_INTRO_180days_37_99_EVERYDOGGY_EVERYDOGGY: 79.78,
  everydoggy_3MONTH_64_99_EUR_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY: 72.23,
  everydoggy_6MONTH_94_99_EUR_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY: 73.13,
  everydoggy_3MONTH_64_99_EUR_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY: 53.62,
  everydoggy_6MONTH_94_99_EUR_INTRO_180days_29_99_EVERYDOGGY_EVERYDOGGY: 61.87,

  everydoggy_2WEEK_39_99_GBP_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY: 59.79,
  everydoggy_1MONTH_49_99_GBP_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY: 70.71,
  everydoggy_1MONTH_49_99_GBP_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY: 68.08,

  everydoggy_2WEEK_39_99_EUR_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY: 71.40,
  everydoggy_1MONTH_49_99_EUR_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY: 83.20,
  everydoggy_1MONTH_49_99_EUR_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY: 76.48,

};

export function eLTVChecker(key: string): number {
  return ELTV_CONFIG[key] ?? 0;
}

export function eLTVLocalChecker(key: string): number {
  return ELTV_LOCAL_CONFIG[key] ?? ELTV_CONFIG[key] ?? 0;
}
